var map = {
	"./AAB.jpg": 1627,
	"./ABK.jpg": 9391,
	"./ADCB.jpg": 407,
	"./ADIB.jpg": 9609,
	"./AHB.jpg": 8200,
	"./AJMAN.jpg": 8348,
	"./ALK.jpg": 3305,
	"./ALMASRAF.jpg": 984,
	"./AMCB.png": 3318,
	"./ARABBANK.jpg": 5145,
	"./BARCLAYS.jpg": 2272,
	"./BBF.jpg": 6285,
	"./BM.jpg": 9248,
	"./BNP.jpg": 7119,
	"./BOC.jpg": 4703,
	"./BS.png": 90,
	"./BSI.jpg": 7369,
	"./CA.jpg": 9887,
	"./CBD.jpg": 6174,
	"./CBI.jpg": 2927,
	"./CITI.jpg": 2174,
	"./DB.jpg": 9185,
	"./DIB.jpg": 8454,
	"./EIB.jpg": 7943,
	"./EIN.jpg": 8595,
	"./ENBD.jpg": 2892,
	"./FBAB.jpg": 1658,
	"./GIB.jpg": 6233,
	"./HABIB.jpg": 2987,
	"./IB.jpg": 9506,
	"./MASHREQ.jpg": 1230,
	"./NBF.jpg": 8081,
	"./NBQ.jpg": 7314,
	"./NI.jpg": 3304,
	"./RAK.jpg": 1057,
	"./SAMBA.jpg": 2505,
	"./SIB.png": 8405,
	"./UAB.jpg": 6847,
	"./bmi.jpg": 3615,
	"./bob.jpg": 6514,
	"./bok.jpg": 1671,
	"./doha.jpg": 4517,
	"./ferg.jpg": 5253,
	"./hbl.jpg": 3141,
	"./hsbc.jpg": 1437,
	"./icbc.jpg": 4838,
	"./idb.jpg": 8244,
	"./mastercard.png": 5083,
	"./nbb.jpg": 8829,
	"./nbk.jpg": 3800,
	"./nile.jpg": 2253,
	"./scb.jpg": 2579,
	"./ubl.jpg": 224,
	"./visa.png": 5912,
	"./wio.png": 2996,
	"./zand.png": 8914
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2189;